exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tex-area-label {\n  padding-bottom: 7px; }\n\ntextarea {\n  width: 100%;\n  height: 88px;\n  padding: 10px;\n  border: 1px solid #DFE1E6;\n  border-radius: 4px;\n  resize: none;\n  outline: none; }\n\ntextarea:-ms-input-placeholder {\n  color: #DFE1E6;\n  size: 14px; }\n\ntextarea::placeholder {\n  color: #DFE1E6;\n  size: 14px; }\n\n.mt-0 {\n  margin-top: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/act-text-area/act-text-area.component.scss
// module id = 870
// module chunks = 22